// Currency display helper. Billing amounts from the backend arrive as
// dollar strings (Prisma Decimal serialized via `.toFixed(2)`), never cents —
// mirrors files-viewer/src/utils/money.ts's formatMoneyDollars.
export function formatMoneyDollars(value: string | number): string {
    return Number(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

// 12345 -> $12.3k, 2225176 -> $2.2M — compact form for chart axis ticks and
// on-bar labels, same thresholds as files-viewer's OverviewCharts.moneyCompact.
export function formatMoneyCompact(value: number): string {
    if (Math.abs(value) >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
    if (Math.abs(value) >= 1000) return `$${Math.round(value / 100) / 10}k`;
    return `$${Math.round(value)}`;
}
